import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/android': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M89.6 204.5v115.8c0 15.4-12.1 27.7-27.5 27.7-15.3 0-30.1-12.4-30.1-27.7v-115.8c0-15.1 14.8-27.5 30.1-27.5 15.1 0 27.5 12.4 27.5 27.5zM100.4 361.5v-179.4h247.3v179.4c0 16.4-13.2 29.6-29.4 29.6h-20.2v61.1c0 36.8-55.5 36.7-55.5 0v-61.1h-37.2v61.1c0 36.6-55.2 36.9-55.2 0l-0.3-61.1h-19.9c-16.4 0-29.6-13.2-29.6-29.6zM348.4 172.4h-249.1c0-42.8 25.6-80 63.6-99.4l-19.1-35.3c-2.8-4.9 4.3-8 6.7-3.8l19.4 35.6c34.9-15.5 75-14.7 108.3 0l19.3-35.5c2.5-4.3 9.5-1.1 6.7 3.8l-19.1 35.2c37.7 19.4 63.3 56.6 63.3 99.4zM177.7 116.9c0-5.7-4.6-10.5-10.5-10.5-5.7 0-10.2 4.8-10.2 10.5 0 5.7 4.6 10.5 10.2 10.5 5.9 0 10.5-4.8 10.5-10.5zM291.1 116.9c0-5.7-4.6-10.5-10.2-10.5-5.9 0-10.5 4.8-10.5 10.5 0 5.7 4.6 10.5 10.5 10.5 5.6 0 10.2-4.8 10.2-10.5zM385.9 177c15.3 0 30.1 12.1 30.1 27.5v115.8c0 15.3-14.7 27.7-30.1 27.7-15.1 0-27.5-12.3-27.5-27.7v-115.8c0-15.4 12.4-27.5 27.5-27.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/android.js
// module id = null
// module chunks = 